module.exports = __webpack_public_path__ + "img/id.d6d20b8f.svg";